export default __webpack_public_path__ + "static/media/hinted-subset-UbuntuMono-Regular.5d9e1cdc.woff";